import { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

import { FaPaperPlane, FaPhone } from "react-icons/fa";


const ContactDialog = function ({ open, handleClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleSendEmail = () => {
    var objData = {
      email,
      message,
    };

    fetch("https://formspree.io/f/xeqvklkj", {
      method: "POST",
      body: JSON.stringify(objData),
      headers: {
        Accept: "application/json",
      },
    }).then((response) => {
      console.log("success!");
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" heigth="300px">
      <DialogTitle id="form-dialog-title">Contato</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Para entrar em contato com nossa equipe basta preencher seus dados abaixo. Responderemos o
          mais rápido possível. <br />
          <br />
          Caso preferir, podemos atendê-lo(a) pelo número:
          <br />{" "}
          <span>
            <FaPhone /> (16) 99361-8378
          </span>
          <br />
        </DialogContentText>
        <form>
          <TextField autoFocus margin="dense" id="name" label="Nome" type="name" fullWidth />

          <TextField
            margin="dense"
            id="email"
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={handleChangeEmail}
          />

          <TextField
            margin="dense"
            id="phone"
            label="Celular"
            useRef="phone"
            name="phone"
            type="text"
            fullWidth
          ></TextField>

          <TextField
            id="mensagem"
            label="Mensagem"
            multiline
            rows={8}
            rowsMax={10}
            size="medium"
            fullWidth
            margin="dense"
            value={message}
            onChange={handleChangeMessage}
          />
        </form>

        <DialogContentText>Fique tranquilo(a), não enviaremos span. </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} bg="red">
          Fechar
        </Button>
        <Button onClick={handleSendEmail} startIcon={<FaPaperPlane />} type="primary">
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactDialog;
